import { Button } from "antd";
import styled from "styled-components";

export const CardTitle = styled.div`
  background-color: #d3e8ff;
  color: #1070b6;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  letter-spacing: 0.3px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const CardBody = styled.div`
  background-color: #ffffff;
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const Counter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 30px;
  margin-right: 30px;
`;

export const CreditAmount = styled.span`
  font-size: 32px;
  font-weight: bold;
  color: #282828;
`;

export const CounterButton = styled(Button)`
  background-color: #d3e8ff;
  color: #1070b6;
  font-size: 30px;
  font-weight: bold;
  border: none;

  :hover,
  :focus,
  :active,
  :visited {
    background-color: #d3e8ff;
    color: #1070b6;
  }
`;

export const Description = styled.span`
  font-size: 14px;
  color: #1070b6;
  font-weight: bold;
  letter-spacing: 0.3px;
`;
